import React from "react";

/**
 * Static Plenty Rydez hero backdrop.
 * The image carries the full brand messaging (Plenty Rydez · Luxury Transportation ·
 * Exclusive · Professional · Reliable) plus the S-Class + Maybach GLS + NYC skyline artwork.
 * Cinematic Sora video lives ONLY on the mobile PWA intro (`/m` on phones).
 */
const BACKDROP = "/brand/hero-backdrop.png";

export default function HeroImage() {
  return (
    <div className="absolute inset-0 overflow-hidden bg-[#071A2F]">
      <img
        src={BACKDROP}
        alt="Plenty Rydez — Luxury Transportation"
        className="absolute inset-0 w-full h-full object-contain sm:object-cover object-center"
      />
      {/* Bottom fade so CTAs remain readable on Midnight Navy */}
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-[#071A2F]" />
    </div>
  );
}
